export default "__VITE_ASSET__CSRQsrpJ__"